import { inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  getActivatedRouteMergedParams,
  getActivatedRouteMergedParamsFromRootToLastChild
} from "src/app/support/activated-route";

export function injectId(): string {
  return injectParam("id");
}

export function injectUuid(): string {
  return injectParam("uuid");
}

export function injectParam<T = string>(param: string): T {
  const activatedRoute = inject(ActivatedRoute);
  const params = getActivatedRouteMergedParamsFromRootToLastChild(
    activatedRoute.snapshot,
    {}
  );
  return params[param] as T;
  //  return <T>activatedRoute.snapshot.params[param];
}

export function injectQueryParam(queryParam: string): string | undefined {
  return inject(ActivatedRoute).snapshot.queryParams[queryParam];
}
